import React from 'react';
import PromptDialogNative from './PromptDialog.native';

// Para web, reutilizamos a mesma implementação baseada em componentes RN, pois react-native-web suporta Modal.
export default PromptDialogNative; 